import React, { useState } from "react";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ChangePasswordDialog({ open, onOpenChange, forced = false }) {
  const { refreshMe } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error("La nueva contraseña debe tener al menos 6 caracteres"); return; }
    if (next !== confirm) { toast.error("Las contraseñas no coinciden"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Contraseña actualizada correctamente");
      reset();
      await refreshMe();
      onOpenChange(false);
    } catch (err) {
      toast.error(apiErrorMessage(err, "No se pudo cambiar la contraseña"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!forced) onOpenChange(v); }}>
      <DialogContent className="sm:max-w-md" data-testid="change-password-dialog" onInteractOutside={(e) => forced && e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>Cambiar contraseña</DialogTitle>
          <DialogDescription>
            {forced
              ? "Por seguridad, debes establecer una nueva contraseña antes de continuar."
              : "Introduce tu contraseña actual y la nueva."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="cp-current">Contraseña actual</Label>
            <Input id="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="cp-current-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="cp-new">Nueva contraseña</Label>
            <Input id="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="cp-new-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="cp-confirm">Repetir nueva contraseña</Label>
            <Input id="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm-input" />
          </div>
          <DialogFooter>
            {!forced && <Button type="button" variant="ghost" onClick={() => onOpenChange(false)}>Cancelar</Button>}
            <Button type="submit" disabled={saving} data-testid="cp-submit-button">{saving ? "Guardando…" : "Guardar"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
